// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global CSS file (e.g., styles.css) */
.thin-scrollbar::-webkit-scrollbar {
  width: 0px; /* Width of the scrollbar */
}

.thin-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1; /* Track color */
}

.thin-scrollbar::-webkit-scrollbar-thumb {
  background-color: #888; /* Scrollbar color */
  border-radius: 10px; /* Rounded corners */
}

.thin-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Scrollbar color on hover */
}
`, "",{"version":3,"sources":["webpack://./src/Theory/sidebarScroll.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;AACvC;;AAEA;EACE,sBAAsB,EAAE,oBAAoB;EAC5C,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,sBAAsB,EAAE,6BAA6B;AACvD","sourcesContent":["/* Global CSS file (e.g., styles.css) */\n.thin-scrollbar::-webkit-scrollbar {\n  width: 0px; /* Width of the scrollbar */\n}\n\n.thin-scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Track color */\n}\n\n.thin-scrollbar::-webkit-scrollbar-thumb {\n  background-color: #888; /* Scrollbar color */\n  border-radius: 10px; /* Rounded corners */\n}\n\n.thin-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: #555; /* Scrollbar color on hover */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
